<div class="start-content" style="height: 100%">
    <amplify-authenticator [hideSignUp]="true">
        <ng-template amplifySlot="authenticated">
            <router-outlet></router-outlet>
            <ppw-loader></ppw-loader>
        </ng-template>

        <ng-template amplifySlot="sign-in">
            <ppw-login></ppw-login>
        </ng-template>
    </amplify-authenticator>
</div>
